<template>
  <vs-popup
    :title="$t('ImagePreview')"
    :active.sync="showModal"
    class=" pt-0"
  >
    <div class="pb-20 flex justify-between">
      <div class="flex">
        <vs-button
        class="p-2"
        color="success"
        type="gradient"
        icon-pack="feather"
        icon="icon-search"
        @click.prevent="magnify('myimage', 2)"
      ></vs-button>
      <vs-button
        class="p-2 mr-5"
        color="primary"
        type="gradient"
        icon-pack="feather"
        icon="icon-rotate-ccw"
        @click.prevent="rotation()"
      ></vs-button>
      </div>

      <div>
        <span class="ml-3">{{ $t("TotalAmountOrder") }}</span>
        <span>{{ totalPrice ? totalPrice : "" }}</span>
      </div>
      <div>
        <span class="ml-3">{{ $t("DateSettlement") }}</span>
        <span>{{ date ? date : "" }}</span>
      </div>
      <vs-button
        class="p-2"
        color="danger"
        type="gradient"
        icon-pack="feather"
        icon="icon-x"
        @click.prevent="notMagnify('myimage', 2)"
      ></vs-button>
    </div>
    <div class="img-magnifier-container "          
    v-bind:style="{transform: `rotate(${deg}deg)`}"

    >
      <div id="imgForZoom"></div>
      <img
        :src="URLS_CONSTANTS.assets + 'baskets/' + model"
        class="block mx-auto w-full my-0 text-center  transition"
        id="myimage"
        style="width: 70%!important"
      />
    </div>
  </vs-popup>
</template>

<script>
import { URLS_CONSTANTS } from "../../../../config";
export default {
  name: "basketManagement_ChannelBaskets_imagePopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    totalPrice: { default: "" },
    date: { default: "" },
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  data() {
    return {
      URLS_CONSTANTS: URLS_CONSTANTS,
      deg:0,
    };

  },
  methods: {
    load() {
      this.onShowDiscountCount = this.$route.params.pageNum;
    },
    rotation() {
      this.deg += 90;
    },
    magnify(imgID, zoom) {
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);
      /*create magnifier glass:*/
      glass = document.getElementById("imgForZoom");
      glass.setAttribute("class", "img-magnifier-glass");
      /*insert magnifier glass:*/
      img.parentElement.insertBefore(glass, img);
      /*set background properties for the magnifier glass:*/
      glass.style.backgroundImage = "url('" + img.src + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
      /*execute a function when someone moves the magnifier glass over the image:*/
      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);
      /*and also for touch screens:*/
      glass.addEventListener("touchmove", moveMagnifier);
      img.addEventListener("touchmove", moveMagnifier);
      function moveMagnifier(e) {
        var pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > img.width - w / zoom) {
          x = img.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > img.height - h / zoom) {
          y = img.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = x - w + "px";
        glass.style.top = y - h + "px";
        /*display what the magnifier glass "sees":*/
        glass.style.backgroundPosition =
          "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      }
      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    },
    notMagnify(imgID, zoom) {
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);
      /*create magnifier glass:*/
      glass = document.getElementById("imgForZoom");
      glass.removeAttribute("class", "img-magnifier-glass");
      // /*insert magnifier glass:*/
      // img.parentElement.insertBefore(glass, img);
      // /*set background properties for the magnifier glass:*/
      // glass.style.backgroundImage = "url('" + img.src + "')";
      // glass.style.backgroundRepeat = "no-repeat";
      // glass.style.backgroundSize =
      //   img.width * zoom + "px " + img.height * zoom + "px";
      // bw = 3;
      // w = glass.offsetWidth / 2;
      // h = glass.offsetHeight / 2;
      // /*execute a function when someone moves the magnifier glass over the image:*/
      // glass.addEventListener("mousemove", moveMagnifier);
      // img.addEventListener("mousemove", moveMagnifier);
      // /*and also for touch screens:*/
      // glass.addEventListener("touchmove", moveMagnifier);
      // img.addEventListener("touchmove", moveMagnifier);
      // function moveMagnifier(e) {
      //   var pos, x, y;
      //   /*prevent any other actions that may occur when moving over the image*/
      //   e.preventDefault();
      //   /*get the cursor's x and y positions:*/
      //   pos = getCursorPos(e);
      //   x = pos.x;
      //   y = pos.y;
      //   /*prevent the magnifier glass from being positioned outside the image:*/
      //   if (x > img.width - w / zoom) {
      //     x = img.width - w / zoom;
      //   }
      //   if (x < w / zoom) {
      //     x = w / zoom;
      //   }
      //   if (y > img.height - h / zoom) {
      //     y = img.height - h / zoom;
      //   }
      //   if (y < h / zoom) {
      //     y = h / zoom;
      //   }
      //   /*set the position of the magnifier glass:*/
      //   glass.style.left = x - w + "px";
      //   glass.style.top = y - h + "px";
      //   /*display what the magnifier glass "sees":*/
      //   glass.style.backgroundPosition =
      //     "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      // }
      // function getCursorPos(e) {
      //   var a,
      //     x = 0,
      //     y = 0;
      //   e = e || window.event;
      //   /*get the x and y positions of the image:*/
      //   a = img.getBoundingClientRect();
      //   /*calculate the cursor's x and y coordinates, relative to the image:*/
      //   x = e.pageX - a.left;
      //   y = e.pageY - a.top;
      //   /*consider any page scrolling:*/
      //   x = x - window.pageXOffset;
      //   y = y - window.pageYOffset;
      //   return { x: x, y: y };
      // }
    },
  },
};
</script>
<style scoped>
.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 100%;
  height: 50%;
}
.transition {
  transition: transform 0.5s ease-in-out;
}
</style>
